import { productCountStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductCount";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

productCountStyles.countText = {
    css: css`
        white-space: nowrap;
    `,
    weight: 700,
};

productCountStyles.wrapper = {
    css: css`
        margin-top: -24px;
        ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(
            theme,
            [
                null,
                css`
                    margin-top: 0;
                `,
            ],
            "max",
        )}
    `,
};
